import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type IpnsFailToDecryptKeyErrorOptions = {
  record?: ObjectId;
};

export class IpnsFailToDecryptKeyError extends FleekError<IpnsFailToDecryptKeyErrorOptions> {
  public name = 'IpnsFailToDecryptKeyError';

  toString = () => `Failed to decrypt IPNS key.`;
}
